export default __webpack_public_path__ + "static/media/Snd_CS.c2d19aa1.mp3";